// src/components/pages/Pessoa/tabs/PessoaTabEnderecos.jsx

import React from 'react';
import { ThemeProvider } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, Button, Tooltip, IconButton, Typography, TextField } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import Input from '../../../form/Input';
import InputFloat from '../../../form/InputFloat';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';

import maskCEP from '../../../../utils/maskCEP';

import { podeEditarItem, podeCancelarItem } from '../../../../hooks/usePermisionMRT';

const PessoaTabEnderecos = ({ theme, module, mrt, ufs, EnumTipoEndereco }) => {
    const { items, rowCount, isLoading, isRefetching, isError, novoEndereco, optionsMunicipio } = module.state;
    const { change, focus, blur, limpar, submit, handleEditarOuDeletar } = module.actions;
    const columns = module.columns;

    return (
        <div>
            <Box sx={{ display: 'grid', gap: 2, marginBottom: '10px' }}>
                <Typography variant="h6">Informações do endereço da pessoa</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Input
                        text="CEP"
                        type="text"
                        name="novoEndereco.cep"
                        maxLength={10}
                        inputWidth="100px"
                        placeholder="CEP"
                        title="Digite o CEP do endereço"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.cep ? maskCEP(novoEndereco.cep) : ''}
                    />

                    <Select
                        text="Estado"
                        name="novoEndereco.ufId"
                        options={ufs}
                        title="Escolha o estado"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.ufId || ''}
                        isEnum={false}
                    />

                    <Select
                        text="Município"
                        name="novoEndereco.municipioId"
                        options={optionsMunicipio}
                        title="Escolha o município"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.municipioId || ''}
                        isEnum={false}
                    />

                    <Input
                        text="Bairro"
                        type="text"
                        name="novoEndereco.bairro"
                        placeholder="Bairro"
                        title="Digite o bairro"
                        inputWidth="220px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.bairro || ''}
                    />

                    <Input
                        text="Logradouro"
                        type="text"
                        name="novoEndereco.logradouro"
                        placeholder="Logradouro"
                        title="Digite o logradouro"
                        inputWidth="260px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.logradouro || ''}
                    />

                    <Input
                        text="Número"
                        type="text"
                        name="novoEndereco.numero"
                        placeholder="Número"
                        title="Digite o número"
                        inputWidth="90px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.numero || ''}
                    />

                    <Input
                        text="Quadra"
                        type="text"
                        name="novoEndereco.quadra"
                        placeholder="Quadra"
                        title="Digite a quadra"
                        inputWidth="90px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.quadra || ''}
                    />

                    <Input
                        text="Complemento"
                        type="text"
                        name="novoEndereco.complemento"
                        placeholder="Complemento"
                        title="Digite o complemento"
                        inputWidth="220px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.complemento || ''}
                    />

                    <Input
                        text="Endereço bancário simplificado"
                        type="text"
                        name="novoEndereco.enderecoBancarioSimplificado"
                        placeholder="Opcional — até 40 caracteres"
                        title="Versão curta deste mesmo endereço, com até 40 caracteres. O endereço completo permanece cadastrado."
                        inputWidth="320px"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.enderecoBancarioSimplificado ?? ''}
                    />

                    <InputFloat
                        text="Latitude"
                        type="text"
                        name="novoEndereco.latitude"
                        placeholder="Latitude"
                        title="Latitude"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.latitude || ''}
                        textAlign="right"
                    />

                    <InputFloat
                        text="Longitude"
                        type="text"
                        name="novoEndereco.longitude"
                        placeholder="Longitude"
                        title="Longitude"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.longitude || ''}
                        textAlign="right"
                    />

                    <Select
                        name="novoEndereco.tipo"
                        text="Tipo do endereço"
                        options={EnumTipoEndereco}
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.tipo || 'Outros'}
                        isEnum={true}
                    />

                    <Checkbox
                        title="Quando marcado torna o endereço como principal"
                        text="Principal"
                        name="novoEndereco.principal"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.principal}
                        checked={!!novoEndereco.principal}
                    />

                    <Checkbox
                        title="Quando marcado torna o endereço ativo"
                        text="Ativo"
                        name="novoEndereco.ativo"
                        handleOnChange={change}
                        handleOnFocus={focus}
                        handleOnBlur={blur}
                        value={novoEndereco.ativo}
                        checked={!!novoEndereco.ativo}
                    />

                    <Button variant="contained" color="inherit" onClick={limpar} style={{ marginLeft: '10px' }}>
                        Limpar
                    </Button>

                    <Button
                        variant="contained"
                        color={String(novoEndereco.funcao).toLowerCase() === 'deletar' ? 'error' : 'info'}
                        disabled={!novoEndereco.cep}
                        onClick={submit}
                        style={{ marginLeft: '10px' }}
                    >
                        {novoEndereco.funcao}
                    </Button>
                </Box>
            </Box>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: { align: 'center' },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': {
                            enableColumnActions: false,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    <IconButton
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Editar')}
                                        disabled={!podeEditarItem()}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Deletar')}
                                        disabled={!podeCancelarItem()}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={items}
                    rowCount={rowCount}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting: mrt.sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};

export default React.memo(PessoaTabEnderecos);
